import { createActionConst } from '../../../utils/action.utils';

const LABEL_NAMESPACE = 'LABEL';

export const STORE_LABEL = createActionConst(LABEL_NAMESPACE, 'STORE_LABEL');
export const CLEAR_LABEL = createActionConst(LABEL_NAMESPACE, 'CLEAR_LABEL');
